<template lang="pug">
modal#no-credit-modal(
  :process-button-label='$t("button.ok")'
  :showCancelButton='false'
  :title='$t("modal.noCredit.title")'
  @process='closeModal'
  ref='modal'
  size='sm'
)
  .text {{ $t('modal.noCredit.message') }}
  .text
    a(href='https://wa.me/556299828935' target='_blank') {{ $t('modal.noCredit.linkText') }}
    span
      |
      | {{ $t('modal.noCredit.consultantMessage') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/mailbox-no-credits.svg')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'NoCreditModal',
  components: {
    Modal,
  },
  methods: {
    async closeModal() {
      this.$emit('saveAndClose');
      this.$refs.modal.close();
    },
  },
};
</script>
